// extracted by mini-css-extract-plugin
export var buttonContainer = "SponsoredProductModal_buttonContainer__4rlNB";
export var container = "SponsoredProductModal_container__233S+";
export var modal = "SponsoredProductModal_modal__rejtv";
export var overlay = "SponsoredProductModal_overlay__k9RMJ";
export var shared = "\"../../../shared/shared.module.css\"";
export var sm = "576px";